module.exports = __webpack_public_path__ + "img/grey-intensives-3.929473d7.png";